import { defineStore } from "pinia";
import { ref } from "vue";
import { useToast } from "vue-toastification";
import themeService from "@/services/theme";

export const useThemesStore = defineStore("themes", () => {
  const toast = useToast();
  const loading = ref(false);

  async function fetchThemesGrid(companyId) {
    loading.value = true;
    try {
      const res = await themeService.getThemes(companyId);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function fetchThemeById(payload) {
    loading.value = true;
    try {
      const res = await themeService.getThemeById(payload);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function addTheme(payload) {
    loading.value = true;
    try {
      const res = await themeService.addTheme(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function editTheme(payload) {
    loading.value = true;
    try {
      const res = await themeService.editTheme(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function deleteTheme(payload) {
    loading.value = true;
    try {
      const res = await themeService.deleteTheme(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function duplicateTheme(payload) {
    loading.value = true;
    try {
      const res = await themeService.duplicateTheme(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  async function restoreDefaultTheme(payload) {
    loading.value = true;
    try {
      const res = await themeService.restoreDefaultTheme(payload);
      toast.success(res.message);
      return res;
    } catch (err) {
      toast.error(err?.data?.message);
      throw err;
    } finally {
      loading.value = false;
    }
  }

  return {
    loading,
    fetchThemesGrid,
    fetchThemeById,
    addTheme,
    editTheme,
    deleteTheme,
    duplicateTheme,
    restoreDefaultTheme,
  };
});
